<template>
    <v-form v-model="valid">
        <v-row>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.bank"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.bank')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.iban"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.iban')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.branch"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.branch')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.swiftCode"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.swift_code')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.account"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.account')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <date-picker
                    v-model="bankTransferDetails.valueDate"
                    outlined
                    dense
                    :label="$t('bank_transfer.value_date')"
                    hide-details
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.reference"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.reference')"
                />
            </v-col>
            <v-col md="6" cols="12">
                <v-text-field
                    v-model="bankTransferDetails.receivingBank"
                    variant="outlined"
                    density="compact"
                    hide-details
                    :label="$t('bank_transfer.receiving_bank')"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel} from 'vue-facing-decorator'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import PaymentRedirectForm from '@/components/booking/forms/PaymentRedirectForm.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component({
        components: {PaymentRedirectForm, DatePicker},
    })
    export class BankTransferForm extends mixins(FormValidationRulesMixin) {
        @VModel() valid
        @Prop() _bankTransferDetails

        @Emit()
        changeBankTransferDetails(val) {
            return val
        }

        mounted() {
            this.bankTransferDetails.valueDate = this.$dateFns.format(new Date())
        }

        get bankTransferDetails() {
            return this._bankTransferDetails
        }

        set bankTransferDetails(val) {
            this.changeBankTransferDetails(val)
        }
    }

    export default BankTransferForm
</script>
